import { atom } from 'jotai'
import type { DrawArea } from '@app/types/layerTypes'
import type { RegionOption } from '@app/components/Molecules/RegionFilter'
import type { IdentifyingInformationFilter } from '@app/types/filterTypes'

export const elementFiltersAtom = atom<IdentifyingInformationFilter>({})

export const drawAreasAtom = atom<DrawArea[]>([])

export const regionMasksAtom = atom<RegionOption[] | null>(null)

export const nonEmptyElementFiltersAtom = atom((get) => {
  const elementFilters = get(elementFiltersAtom)

  return Object.fromEntries(
    Object.entries(elementFilters)
      .map(([layerType, filters]) => {
        const nonEmptyFilters = Object.fromEntries(
          Object.entries(filters).filter(([, fieldFilter]) => fieldFilter.values.length > 0),
        )

        return [layerType, nonEmptyFilters]
      })
      .filter(([, filters]) => Object.keys(filters).length > 0),
  ) as IdentifyingInformationFilter
})

export const hasRiskFiltersAtom = atom((get) => {
  const drawAreas = get(drawAreasAtom)
  const regionMasks = get(regionMasksAtom)
  const elementFilters = get(nonEmptyElementFiltersAtom)

  return (
    drawAreas.length > 0 || Boolean(regionMasks?.length) || Object.keys(elementFilters).length > 0
  )
})

export const regionFiltersAtom = atom<RegionOption[] | null>(null)
